import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { popModal } from '@/redux/modals/actions';
import { getPermissions } from '@/redux/permissions/selectors';
import { actions } from '@/shared/types/permissions';
import { RootState } from '@/shared/types/state';

const useAnalyticsHelper = () => {
  const dispatch = useDispatch();

  const canRead = useSelector((state: RootState) =>
    getPermissions(state, 'analytics', actions.READ)
  );

  useEffect(() => {
    return () => {
      dispatch(popModal());
    };
  }, [dispatch]);

  return { canRead };
};

export default useAnalyticsHelper;
